import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useDate = () => {
    const { i18n, t } = useTranslation();
    const dateToString = useCallback((date) => {
        // Listas de los meses en español e inglés
        const spanish = [
            'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
            'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];

        const english = [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ];

        // Obtener el día, el mes y el año
        const day = date.getDate();
        const monthEs = spanish[date.getMonth()];
        const monthEn = english[date.getMonth()];
        const año = date.getFullYear();

        // Formatear la fecha dependiendo del idioma
        if (i18n.language === 'es') {
            return `${day} de ${monthEs} de ${año}`;
        } else if (i18n.language === 'en') {
            return `${monthEn} ${day}, ${año}`;
        } else {
            return 'Idioma no soportado';
        }
    }, [i18n.language]);
    return { dateToString, t };
}